// ─── Sanctum Lead Capture ──────────────────────────────────────────────────
// POST /api/lead — production worker endpoint. Accepts
// { email, brand, dna, destination } → { ok: true }.
// Never blocks the demo: on any failure (no worker locally, network error,
// non-2xx) we resolve `false` silently so the caller can proceed regardless.

export interface LeadPayload {
  email: string
  brand: 'yonder' | 'passage' | 'sanctum'
  dna: string
  destination: string
}

export async function submitLead(payload: LeadPayload): Promise<boolean> {
  try {
    const res = await fetch('/api/lead', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
    if (!res.ok) return false
    const data = await res.json().catch(() => null)
    return !!data?.ok
  } catch {
    return false
  }
}
